module.exports = __webpack_public_path__ + "static/images/banner.aeda301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/banner.png
// module id = sWaf
// module chunks = 11